<template>
  <div id="app">
    <router-view></router-view>
    <popup-share-tip />
  </div>
</template>

<script>
import PopupShareTip from './components/PopupShareTip.vue';

export default {
  components: { PopupShareTip },
  name: 'App',
  computed: {},
  async mounted() {
    // 解决ios不支持按钮:active伪类的方法
    document.body.addEventListener('touchstart', () => {});

    // document.addEventListener('touchstart', (event) => {
    //   if (event.touches.length > 1) {
    //     event.preventDefault();
    //   }
    // });
    // document.addEventListener('gesturestart', (event) => {
    //   event.preventDefault();
    // });
    function fnResize() {
      const deviceWidth = document.documentElement.clientWidth || window.innerWidth;

      document.documentElement.style.fontSize = `${deviceWidth / 30}px`;
    }
    fnResize();
    window.onresize = () => {
      fnResize();
    };
    // if (this.isQQ) {
    // }
    // if (this.isWechat) {}
  },
  watch: {
    $route: {
      deep: true,
      handler(newValue) {
        const meta = newValue.meta || {};
        this.addCounter();
        if (!meta.visibleAudio) {
          window.audio.pause();
        } else {
          // window.audio.src = this.stateAudio.src;
          // window.audio.src = `http://oss-cfmoto.zeehoev.com/codes/cfmoto-h5/music.mp3?t=${new Date().getTime()}`;
          // window.audio.loop = true;
          // window.audio.play();
        }
      },
    },
  },
};
</script>

<style>
.body {
  overflow: hidden;
}
#app {
  height: 100%;
}

/* img::after {
  content: '';
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background: url('./assets/images/tiezi_zhanweitu@3x.png') no-repeat center;
  background-size: 100%;
} */
img {
  position: relative;
  object-fit: cover;
}
*::-webkit-media-controls-panel {
  overflow: visible;
}
*::-webkit-media-controls-play-button {
  display: none !important;
}

*::-webkit-media-controls-time-remaining-display {
  display: none;
}
*::-webkit-media-controls-current-time-display {
  display: none;
}
*::-webkit-media-controls-timelinen {
  display: none !important;
  padding: 0;
}

*::-webkit-media-controls-start-playback-button {
  display: block !important;
  -webkit-appearance: red;
}
video {
  background: #000;
}

video::-webkit-progress-bar {
  background: red !important;
}
video::-webkit-progress-inner-element {
  background: red !important;
  display: none;
}
video::-webkit-media-controls {
  overflow: visible !important;
  position: relative;
  z-index: 1000;
  opacity: 0.8;
}
*::-webkit-media-controls-timeline {
  margin-bottom: 0px;
  padding-bottom: 4px;
  padding-top: 4px;
  margin-top: -20px;
  width: calc(100% - 90px);
  display: none;
}
*::-webkit-internal-track-segment-background {
  display: none;
}
*::-webkit-media-controls-mute-button {
  display: none;
}
*::-webkit-media-controls-play-button {
  display: none !important;
}
*::-webkit-media-controls-fullscreen-button {
  background-image: url('./assets/images/full.png');
  opacity: 0.8;
}
video::-internal-media-controls-button-panel {
  overflow: visible !important;
}
</style>
